import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Image from 'global/Image';
import { CloseOutlined } from '@ant-design/icons';

const Avatar = dynamic(() => import('react-avatar-edit'), { ssr: false });

// ComposeModalCroppingImage Component
function ComposeModalCroppingImage({
  buttonSubmitTitle,
  title,
  src,
  onCloseModal,
  onCancelModal,
  onSubmitModal,
}) {
  const [textBtnSubmit, setTextBtnSubmit] = useState(buttonSubmitTitle);
  const [preview, setPreview] = useState('');

  useEffect(() => {
    setTextBtnSubmit(buttonSubmitTitle);
  }, [buttonSubmitTitle]);

  // func onCrop to set preview image
  const onCrop = (croppedImage) => {
    setPreview(croppedImage);
  };

  // func onClose set preview image to null
  const onClose = () => {
    setPreview(null);
  };

  const onSubmitForm = (e) => {
    e.preventDefault();

    if (!preview) return false;

    onSubmitModal(preview);

    return false;
  };

  const handlerCloseModal = (e) => {
    e.preventDefault();

    if (typeof onCloseModal === 'function') {
      onCloseModal();
    }

    onCancelModal();
  };

  return (
    <div
      id="modal-cropping"
      className=" option-wrap modal-wl-edit"
      style={{ display: 'block' }}
    >
      <form onSubmit={onSubmitForm}>
        <span>
          <div className="modal-general-in">
            <CloseOutlined
              role="button"
              aria-label="Close cropped image"
              tabIndex="0"
              className="modal-title-close close-option"
              onClick={handlerCloseModal}
              onKeyUp={handlerCloseModal}
            />
            <div className="modal-title">{title}</div>
            <div className="circle-cropping">
              <div>
                <Avatar
                  imageHeight={280}
                  width={390}
                  height={295}
                  src={src}
                  onCrop={onCrop}
                  onClose={onClose}
                  minCropRadius={0}
                />
              </div>
              {preview && (
                <Image
                  style={{
                    width: '200px',
                    height: '200px',
                    display: 'block',
                    margin: '0 auto',
                  }}
                  src={preview}
                  alt="Preview"
                />
              )}
            </div>
            <input
              type="button"
              defaultValue="Cancel"
              className="option modal-button modal-cancel"
              onClick={handlerCloseModal}
            />
            <input
              id="croppingavatar"
              type="submit"
              value={textBtnSubmit}
              className="option modal-button modal-save"
            />
          </div>
        </span>
      </form>
    </div>
  );
}

ComposeModalCroppingImage.propTypes = {
  onCancelModal: PropTypes.func,
  onSubmitModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  buttonSubmitTitle: PropTypes.string,
  title: PropTypes.string,
  src: PropTypes.string,
};

ComposeModalCroppingImage.defaultProps = {
  onCancelModal: () => {},
  onSubmitModal: () => {},
  onCloseModal: () => {},
  buttonSubmitTitle: 'Save',
  title: '',
  src: '',
};

export default ComposeModalCroppingImage;
